"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.27 24h-22.54a.64.64 0 0 1 -.73-.73v-22.54a.64.64 0 0 1 .73-.73h22.54a.64.64 0 0 1 .73.73v22.54a.64.64 0 0 1 -.73.73z",
    fill: "#e4342a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m14 12 6.18-6.18a1.41 1.41 0 0 0 -2-2l-6.18 6.18-6.18-6.17a1.41 1.41 0 0 0 -2 2l6.18 6.17-6.17 6.18a1.41 1.41 0 0 0 0 2 1.44 1.44 0 0 0 1 .41 1.4 1.4 0 0 0 1-.41l6.17-6.18 6.18 6.18a1.4 1.4 0 0 0 1 .41 1.44 1.44 0 0 0 1-.41 1.41 1.41 0 0 0 0-2z",
    fill: "#fff"
  }));
};

exports["default"] = _default;